import { Layout } from './layout/Layout';
import { StoreSelection } from './storeSelection';

const { REACT_APP_PUBLIC_URL = '/' } = process.env;

const createRoutes = (prefix, baseUrl) => [
  {
    name: `${prefix}`,
    path: `${baseUrl}?tableNumber&utm_source&utm_medium&utm_campaign&utm_term&utm_content&gclid&msclkid&fbclid&spMailingID&spUserID&spJobID&spReportId&_ga&locale&productID`,
    component: Layout,
  },
  {
    name: `${prefix}.claim`,
    path: '/claim/:orderUUID',
    component: StoreSelection,
    key: 'storeSelection',
  },
  {
    name: `${prefix}.store-selection`,
    path: '/store/store-selection?app',
    component: StoreSelection,
    key: 'storeSelection',
  },
  {
    name: `${prefix}.welcome`,
    path: '/welcome',
  },
  {
    name: `${prefix}.profile`,
    path: '/profile?:fromRoute&:fromParams',
  },
  {
    name: `${prefix}.profile.orders-history`,
    path: '/orders-history',
  },
  {
    name: `${prefix}.profile.rewards`,
    path: '/rewards',
  },
  {
    name: `${prefix}.account`,
    path: '/account',
  },
  {
    name: `${prefix}.account.auth`,
    path: '/auth?:fromRoute&:fromParams',
  },
  {
    name: `${prefix}.account.auth.login`,
    path: '/login',
  },
  {
    name: `${prefix}.account.auth.register`,
    path: '/register',
  },
  {
    name: `${prefix}.store`,
    path: '/store/:storeUUID',
  },
  {
    name: `${prefix}.store.menu`,
    path: '/menu?:menuUUID',
  },
  {
    name: `${prefix}.store.menu.overview`,
    path: '/overview?categoryUUID',
  },
];

export const routes = [
  ...createRoutes('preorder', ''),
  ...createRoutes('opat', `${REACT_APP_PUBLIC_URL}o`),
  ...createRoutes('delivery', `${REACT_APP_PUBLIC_URL}delivery`),
];
